<div class="p-8 bg-color-white text-grey-900 rounded-xl shadow-[0_2px_5px_rgba(0,0,0,0.1)]">
  <div class="mb-8">
    <h3 class="text-lg font-bold">{{ title }}</h3>
    <p class="text-lg text-grey-600 h-14">{{ subtitle }}</p>
  </div>
  <div class="mb-6 h-[3.75rem]">
    <span [class.invisible]="!showStartingAt" class="mb-2 text-sm text-grey-600">Starting at</span>
    @if (isLoading) {
      <div class="animate-pulse h-5 bg-grey-500 rounded-md dark:bg-gray-700 w-full max-w-36 mt-2"></div>
    } @else {
      <div class="flex gap-2 items-baseline text-3xl">
        <span class="font-semibold text-grey-900">{{ '$' + price }}</span>
        <span [class.invisible]="period === ''" class="text-sm text-grey-600">{{ period }}</span>
      </div>
    }
  </div>
  <button class="be-button" [disabled]="isDisabled" (click)="buttonClick.emit()">
    {{ buttonText }}
  </button>
</div>
